import React from 'react';

const NavBar = props => {
    return (
        <nav>
            <a href='#about'>About</a>|
            <a href='#work'>Work</a>|
            <a href='#contact'>Contact</a>
        </nav>
    )
}

export default NavBar;